import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson4: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson3"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative">Stock Intro</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson5"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[8.13rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.13rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What is a Stock?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  When you purchase a stock from a company, you become a
                  shareholder, and the small piece you own is called a share.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Investors buy and own stocks in hopes that the company will
                  succeed. When the company does well, its stock owners share in
                  those profits.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Conversely, shareholders can also expect their returns to be
                  diminished if the company underperforms or declines. And in
                  the worst-case scenario, a stock owner's shares could become
                  worthless if the company was to go bankrupt.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[22.25rem] object-cover"
            alt=""
            src="/i14@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Companies can issue their stock shares either privately or publicly.
          </p>
          <p className="m-0">
            Private companies "go public" to raise money for business
            initiatives such as launching new products or services expanding its
            reach. They do this through IPO’s
          </p>
          <p className="m-0">
            Investors can buy and sell public stocks by opening an account with
            a stock broker.
          </p>
          <p className="m-0">
            There are two primary ways that shareholders can earn returns on
            their investments: capital gains and dividends.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.81rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span className="text-white">Tickers</span>
              </b>
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  A stock ticker is how information about a stock is presented
                  to investors. A stock ticker symbol is a short code used to
                  identify a company that issues stocks or securities. These
                  identification codes were designed by the exchanges and kept
                  short to help investors and traders easily identify them.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  There may be up to four letters on the New York Stock
                  Exchange. The Nasdaq uses up to five, but some may use less.
                  The Coca-Cola Company, for instance, uses the ticker symbol
                  KO.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[46.47rem] h-[22.25rem] object-cover"
            alt=""
            src="/i15@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Knowing a firm's ticker symbol is vital when it comes to buying or
            selling shares. If a trading friend talks about a trending stock,
            and another trader enters the wrong ticker symbol while making a
            trade, that trader ends up with the wrong asset. That can be a
            costly mistake.
          </p>
          <p className="m-0">
            When a ticker symbol has an "E" after its name, that means the
            company has not met regulatory rules for financial reporting.
          </p>
          <p className="m-0">
            Companies can offer more than one type of stock, so there may be a
            need to have more than one ticker. Tickers can add an extra letter
            or use a period or hyphen within the code to let people know there
            are different stocks in one company.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Market Hours </b>
          </p>
          <p className="m-0">
            The pre-market trades from 4 a.m. to 9:30 a.m. ET.
          </p>
          <p className="m-0">
            The regular market trades from 9:30 a.m. to 4 p.m. ET.
          </p>
          <p className="m-0">
            The after-hours market trades from 4 p.m. to 8 p.m. ET
          </p>
          <p className="m-0">
            Pre-market trading is the period of trading activity that occurs
            before the regular market session. Many investors and traders watch
            the pre-market trading activity to judge the strength and direction
            of the market in anticipation of the regular trading session.
          </p>
          <p className="m-0">
            After-hours trading is securities trading that starts at 4 p.m. U.S.
            Eastern Time after the major U.S. stock exchanges close. The
            after-hours trading session can run as late as 8 p.m, though volume
            typically thins out much earlier in the session.
          </p>
          <p className="m-0">
            Traders and investors engage in after-hours trading for a variety of
            reasons. They may prefer trading with fewer market participants or
            their schedules may require it. They may want to take positions as a
            result of news that breaks after the close of the stock exchange.
            Or, they may want to close out a position before they leave on
            vacation.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left">
          <p className="m-0">
            <b>
              <span>Options</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                An options contract offers the buyer the opportunity to buy or
                sell before a certain date and at a specified price
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Each options contract will have a specific expiration date by
                which the holder must exercise their option. The stated price on
                an option is known as the strike price.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Options are versatile financial products. These contracts
                involve a buyer and seller, where the buyer pays a premium for
                the rights granted by the contract.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Calls</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A call option gives the holder the right, but not the
                obligation, to buy the underlying security at the strike price
                on or before expiration. A call option will therefore become
                more valuable as the underlying security rises in price.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A long call can be used to speculate on the price of the
                underlying rising, since it has unlimited upside potential but
                the maximum loss is the premium (price) paid for the option
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Call options allow the holder to buy the asset at a stated price
                within a specific timeframe. Put options, on the other hand,
                allow the holder to sell the asset at a stated price within a
                specific timeframe.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Example of a trade</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>c = call p = put</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>$SPY $410c @ $1.26</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Ticker - $SPY</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Strike - $410c</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Premium - @ $1.26</span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Puts</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Opposite to call options, a put gives the holder the right, but
                not the obligation, to instead sell the underlying stock at the
                strike price on or before expiration. A long put, therefore, is
                a short position in the underlying security, since the put gains
                value as the underlying price falls. Protective puts can be
                purchased as a sort of insurance, providing a price floor for
                investors to hedge their positions
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Suppose that Microsoft (MFST) shares trade at $108 per share and
                you believe they will increase in value. You decide to buy a
                call option to benefit from an increase in the stock's price.
                You purchase one call option with a strike price of $115 for one
                month in the future for 37 cents per contact. Your total cash
                outlay is $37 for the position plus fees and commissions (0.37 x
                100 = $37).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If the stock rises to $116, your option will be worth $1, since
                you could exercise the option to acquire the stock for $115 per
                share and immediately resell it for $116 per share. The profit
                on the option position would be 170.3% since you paid 37 cents
                and earned $1—that's much higher than the 7.4% increase in the
                underlying stock price from $108 to $116 at the time of expiry.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In other words, the profit in dollar terms would be a net of 63
                cents or $63 since one option contract represents 100 shares
                [($1 - 0.37) x 100 = $63].
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.75rem] text-left text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Following a Callout </b>
            </p>
            <p className="m-0">
              In the world of Trading, you’ll find experienced traders that
              share traders they are entering. These are called callouts or
              signals.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              As you can see on the left, this is an example of an Options trade
              that they are entering. To follow this trade, here’s how you’d go
              about it:
            </p>
          </div>
          <img
            className="relative w-[46.5rem] h-[22.25rem] object-cover"
            alt=""
            src="/i16@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            BTO means Buy to Open. This means that you are to open the trade
            instantly
          </p>
          <p className="m-0">
            $SHOP is the ticker, this is the Stock they're looking to enter a
            trade on, which is Shopify
          </p>
          <p className="m-0">$40 is the Strike Price they are entering at</p>
          <p className="m-0">C stands for Calls which means a buy</p>
          <p className="m-0">
            @ 0.67 is the premium they will be paying on the options contract
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-gainsboro-100">
          <p className="m-0">
            <b>
              <span className="text-white">Dividends</span>
            </b>
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A dividend stock is a publicly traded company that regularly
                shares profits with shareholders through dividends. These
                companies tend to be both consistently profitable and committed
                to paying dividends for the foreseeable future.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In order to collect dividends on a stock, you simply need to own
                shares in the company through a brokerage account. When the
                dividends are paid, the cash will automatically be deposited
                into your account.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Companies that pay a regular dividend generally pay them
                consistently over time, in part by setting the dividend amount
                to ensure that it's sustainable in both good and bad years.
                Regular dividends are usually paid quarterly, although they can
                also be paid monthly, biannually, or annually.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`Not all companies pay dividends, but many do. Roughly 75% of companies in the S&P 500 pay a regular dividend.`}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Larger and slower-growing businesses are more likely to pay
                dividends to their investors than smaller, faster-growing
                companies. Growing businesses need to retain their earnings to
                continue to expand, while large, established companies are
                already profitable. Most companies with plenty of available cash
                choose to pay a dividend.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.75rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>ETF’s </b>
            </p>
            <p className="m-0 text-[1.56rem] text-gainsboro-100">{`Exchange-traded funds, better known as an ETFs, are similar in many ways to mutual funds. They generally track the price of a basket of assets (like the S&P 500) - making it easy for investors to diversify their portfolios by gaining access to an entire asset class. As their name suggests, they trade on exchanges and can be bought and sold like stock via a traditional brokerage account.`}</p>
          </div>
          <img
            className="relative w-[33.38rem] h-[22.25rem] object-cover"
            alt=""
            src="/i17@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            ETFs are considered to be low-risk investments because they are
            low-cost and hold a basket of stocks or other securities, increasing
            diversification.
          </p>
          <p className="m-0">
            ETFs provide lower average costs because it would be expensive for
            an investor to buy all the stocks held in an ETF portfolio
            individually. Investors only need to execute one transaction to buy
            and one transaction to sell, which leads to fewer broker commissions
            because there are only a few trades being done by investors.
          </p>
          <p className="m-0">
            Brokers typically charge a commission for each trade. Some brokers
            even offer no-commission trading on certain low-cost ETFs, reducing
            costs for investors even further.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span className="text-white">Mutual Funds</span>
              </b>
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Mutual funds are investment strategies that allow you to pool
                  your money together with other investors to purchase a
                  collection of stocks, bonds, or other securities that might be
                  difficult to recreate on your own.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The price of the mutual fund, also known as its net asset
                  value (NAV) is determined by the total value of the securities
                  in the portfolio, divided by the number of the fund's
                  outstanding shares. This price fluctuates based on the value
                  of the securities held by the portfolio at the end of each
                  business day. Note that mutual fund investors do not actually
                  own the securities in which the fund invests; they only own
                  shares in the fund itself.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Mutual funds can be a cost-effective way to invest. While individual
            purchase minimums may vary by fund, most funds will let you buy
            shares with as little as $2,500, and some can be as low as $100.
          </p>
          <p className="m-0">
            There are a variety of fees that may be associated with mutual
            funds. Some funds come with transaction charges for buys and sells
            or commissions known as loads. And there are funds that charge a
            redemption fee if you sell shares you've only owned for a short
            time.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-gainsboro-100">
          <p className="m-0">
            <b>
              <span className="text-white">Hedge Funds</span>
            </b>
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A hedge fund is a limited partnership of private investors whose
                money is managed by professional fund managers who use a wide
                range of strategies to earn above-average investment returns.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Usually high net worth individuals will invest their money into
                these hedge funds. Their money is then managed and invested via
                professional traders. The hedge fund will take a small % of
                profit made as a fee.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Investments in hedge funds are considered illiquid as they often
                require investors to keep their money in the fund for at least
                one year, a time known as the lock-up period. Withdrawals may
                also only happen at certain intervals such as quarterly or
                bi-annually.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As investors research to identify hedge funds that meet their
                investment goals, they often consider the fund or firm's size,
                the track record and longevity of the fund, the minimum
                investment required to participate, and the redemption terms of
                the fund.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The biggest hedge fund in the world is BlackRock. They manage
                over $10 trillion worth of assets around the world
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch h-[48.94rem] flex flex-row items-center justify-center gap-[3.94rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Bonds</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Bonds are like IOUs. When you buy one, you’re basically
                  lending money to a government or company for a fixed period of
                  time in return for interest. The money you lend is known as
                  the principal, or face value. Over the course of the bond you
                  receive regular interest payments, called coupons. And
                  provided the institution doesn’t go bust, at the end of the
                  agreed period you are paid back your principal.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.38rem] h-[22.25rem] object-cover"
            alt=""
            src="/i18@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            There are several types of bonds available to investors. The most
            common:
          </p>
          <p className="m-0">
            Government bonds. IOUs issued by a government to support their
            spending and obligations. Two examples are Gilts (UK government
            bonds) and Treasuries (US government bonds).
          </p>
          <p className="m-0">
            Corporate bonds. Companies ask people to pool together money for a
            loan and then aim to repay what they owe from their earnings and
            cash flow.
          </p>
          <p className="m-0">
            Bonds come with several potential benefits. One that's attractive to
            some investors are the steady, regular interest payments that
            supplement their income.
          </p>
          <p className="m-0">
            Another is that bond and share prices historically tend to react
            differently to changes in the economic cycle. Because they generally
            move independently of each other, an investment portfolio that holds
            both is likely more balanced and less prone to shed significant
            value.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.56rem] text-silver">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Dollar Cost Averaging </b>
          </p>
          <p className="m-0">
            Dollar cost averaging is a strategy in which investment positions
            are built by investing equal sums of money at regular intervals,
            regardless of the asset’s price or what is going on in the financial
            markets.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            These regular investments can be in terms of a fixed amount of
            currency or a fixed number of shares. The intervals can be weekly,
            monthly, yearly or whenever suits an individual’s investment plan
            the best.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A dollar cost averaging benefit is that it takes emotional factors
            out of investing. Since you are regularly making investments no
            matter what the market conditions are, emotions are eliminated out
            of the decision-making process. For example, if the market is on a
            downswing, some investors might panic and sell off their holdings.
            With this approach, it can be seen as an opportunity to buy at low
            prices, keeping in mind that this strategy is typically used for
            long term investment horizons.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This strategy enables investors who do not have a large lump sum of
            money to build a position in a certain product over time. For
            example, some investors might have $10,000 to invest at once.
            Whereas, other individuals might not have such a sum at a certain
            time, but can use this strategy to build up to a position worth
            $10,000.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.75rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Indices</span>
              </b>
            </p>
            <p className="m-0 text-silver">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Indices are single markets that are made up of a selection of
                  stocks. An index's price tracks the combined value of every
                  stock listed within it. Comprised of some of the largest
                  global companies, they are seen as indicators of stock market
                  and economic performance.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>{`Let's take the Dow Jones as an example. `}</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The Dow consists of 30 large US companies, including Apple,
                  IBM and Microsoft. If the stock prices of these companies go
                  up overall, the Dow will go up too. If they go down, the Dow
                  will fall. By measuring the performance of 30 major stocks,
                  the Dow gives an impression of the overall market.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.38rem] h-[22.25rem] object-cover"
            alt=""
            src="/i19@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          If the US economy is booming, it's likely these major companies will
          also be performing well. This is because typical characteristics of a
          strong economy - such as positive consumer sentiment, high spending
          and strong GDP output - will also benefit stocks within that economy.
          So looking at the Dow Jones can give a quick snapshot of how the US
          economy is performing.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Sectors </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <span>
                The U.S. stock market includes thousands of companies, and it’s
                easy to get analysis paralysis at the thought of choosing which
                to invest in. To help simplify things a bit for investors, the
                stock market is broken down into several different sectors that
                include companies with similar characteristics.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A stock market sector is a group of public companies that share
                similar business activities, products and services, or
                characteristics. There are 11 sectors of the U.S. stock market.
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Energy Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <span>
                The energy sector is made up of companies that work in energy
                sources, equipment, and services. Companies in this sector
                engage in a wide range of products and services, including
                drilling, energy exploration and production, storage and
                transportation, marketing, refining, and more. The energy sector
                doesn’t include most renewable energy companies. Instead, it’s
                primarily dominated by oil and gas, along with coal and other
                consumable fuels. Some of the largest companies in the energy
                sector are ExxonMobil and Chevron.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Materials Sector</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`The materials sector is made up of companies that manufacture and market goods used in manufacturing. Included in the materials sector are companies that produce chemicals, construction materials, containers & packaging, metals, paper, and forest products. Some of the largest companies in the materials sector are Sherwin-Williams and DuPont.`}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Consumer Discretionary Sector</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The consumer discretionary sector is made up of those companies
                that produce goods that consumers want but don’t necessarily
                need. These companies tend to be cyclical since they do well
                when the economy is booming but not when the economy is down.
                Some of the largest companies in the consumer discretionary
                sector are Amazon, Tesla, and Home Depot.
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Industrials Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <span>
                The industrials sector includes companies across a wide range of
                different goods and services. Included in the industrials sector
                are aerospace and defense, construction, engineering, electrical
                equipment, machinery, commercial supplies, transportation,
                infrastructure, and some professional services. Some of the
                largest companies in the industrials sector are Honeywell,
                Boeing, and Union Pacific.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Consumer Staples Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <span>{`Opposite of consumer discretionary products, the consumer staples category is made up of those products that people view as needs and that sell no matter how the economy is doing. Included in the consumer staples sector are food, beverages, tobacco, household products, and personal care products. Some of the largest companies in the consumer staples sector are Procter & Gamble, Walmart, and Coca-Cola.`}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Healthcare Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">{`The healthcare sector has two primary categories of companies: healthcare equipment & services companies and pharmaceutical and biotechnology companies. The sector covers everything from healthcare equipment, supplies, distributions, services, facilities, technology, research, development, and more.Some of the largest companies in the healthcare sector are Johnson & Johnson, UnitedHealth Group, and Pfizer.`}</p>
          <p className="m-0 text-[1.75rem]">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-white">
            <b>
              <span>Information Technology Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <span>
                The information technology sector includes a wide range of
                companies involved in the manufacturing, distribution, market,
                and more of both hardware and software. Some of the most common
                components within this sector include IT services, software,
                communication equipment, hardware, electrical equipment, and
                more. Some of the largest companies in the technology sector are
                Apple and Microsoft.
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>Financials Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            The financials sector includes companies in areas of finance. Some
            of the more common industries in this sector include banking,
            mortgages, financial services, consumer finance, asset management,
            capital markets, financial exchanges, REITs, insurance, and more.
            Some of the largest companies in the financials sector are Berkshire
            Hathaway, Visa, and JPMorgan Chase.
          </p>
          <p className="m-0 text-[1.75rem] text-white">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>Communication Services Sector</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`The communication services sector includes many companies across two main categories of communications: telecommunication services and media & entertainment. On the telecommunication services side, you’ll find providers of wireless, fiber-optic, cable, and internet services. On the media & entertainment side are media and broadcasting companies, as well as entertainment companies, streaming services, social media, and more. Some of the largest companies in the consumer services sector are Facebook and Alphabet (the parent company of Google).`}</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem]">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-white">
            <b>
              <span>Utilities Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            We’ve already talked about the energy sector, which includes
            companies that explore, produce, and store energy sources. The
            utilities sector is made up of those companies that deliver energy
            sources to consumers. It includes electric and gas utilities, water
            utilities, and many renewable energy companies. Some of the largest
            companies in the utilities sector are Duke Energy, NextEra Energy,
            and The Southern Company.
          </p>
          <p className="m-0 text-[1.75rem]">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-white">
            <b>
              <span>Real Estate Sector</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0 text-silver">
            The real estate sector is made up of companies involved in the
            development and management of real estate. A large portion of this
            sector is made up of real estate investment trusts (REITs), but it
            also includes other real estate leasing, management, and development
            companies. Some of the largest companies in the real estate sector
            are American Tower Corp. and Simon Property Group.
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[44.94rem] object-cover"
          alt=""
          src="/i20@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left">
          <p className="m-0">
            <b>
              <span>The New York Stock Exchange</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The New York Stock Exchange (NYSE) is a stock exchange located
                in New York City that is the largest equities-based exchange in
                the world, based on the total market capitalization of its
                listed securities.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When you hear of stocks, you immediately think of Wall Street
                and the New York Stock Exchange
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The New York Stock Exchange uses two methods of trading: brokers
                and all-electronic. Regardless of the method of exchange, all
                stock transactions are an auction.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Brokers actively trade stocks on the floor of the NYSE. Buyers
                and sellers auction securities for the highest price. Brokers
                represent the entity buying the stock, whether it's for a retail
                brokerage company or institutional investors such as pension
                funds. The brokers set the "bid" price, which is the price
                you're willing to pay for the stock.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The dealers match up the brokers with the stock sellers, who
                submit an "ask" price. It's usually higher than the bid price.
                In this way, it's like selling a home. The dealer is like the
                real estate agent, who puts the buyer and seller together.
                Dealers get to pocket the difference between the ask and bid
                price, minus fees and expenses, for their work.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Most of the transactions occur electronically. A computer acts
                as the dealer, matching up buyers and sellers. Even the brokers
                and dealers get their information and trade electronically.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left">
          <p className="m-0">
            <b>
              <span>Insider Trading</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Insider trading refers to the practice of purchasing or selling
                a publicly-traded company’s securities while in possession of
                material information that is not yet public information.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By non-public information, we mean that the information is not
                legally out in the public domain and that only a handful of
                people directly related to the information possessed. An example
                of an insider may be a corporate executive or someone in
                government who has access to an economic report before it is
                publicly released.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here’s another example: The CEO of a company divulges important
                information about the acquisition of his company to a friend who
                owns a substantial shareholding in the company. The friend acts
                upon the information and sells all his shares before the
                information is made public.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If someone is caught in the act of insider trading, they can
                either be sent to prison, charged a fine, or both. According to
                the SEC in the US, a conviction for insider trading may lead to
                a maximum fine of $5 million and up to 20 years of imprisonment.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left">
          <p className="m-0">
            <b>
              <span>Penny Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A penny stock typically refers to the stock of a small company
                that trades for less than $5 per share.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In the past, penny stocks were considered any stocks that traded
                for less than $1 per share. The U.S. SEC has modified the
                definition to include all shares trading below $5.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Penny stocks are usually associated with small companies with a
                lack of liquidity, meaning that there are few ready buyers in
                the marketplace. As a result, investors may find it difficult to
                sell stock since there may not be enough buyers. Because of the
                low liquidity, investors might have difficulty finding a price
                that accurately reflects the market.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Due to their lack of liquidity, wide bid-ask spreads or price
                quotes, and small company sizes, penny stocks are generally
                considered highly speculative. In other words, investors could
                lose a sizable amount or all of their investment.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Due to their low volume, penny stocks tend to be more volatile
                than established equities. This means high opportunities for
                both gains and losses, and investors should be careful to
                understand both the risks and benefits.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left">
          <p className="m-0">
            <b>
              <span>IPO’s</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When a private company first sells shares of stock to the
                public, this process is known as an initial public offering
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A lot of people trade IPO’s because of the volatility. During
                the first few weeks of an IPO, price will make large moves in
                order find the right value for the stock.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                 Public companies are subjected to the rules and regulations of
                a governing body. One of the rules is that the company is
                required to publicly disclose financials, such as accounting
                information, tax and profits. IPOs also carry significant costs
                and could require the company to raise additional funding if its
                shares perform poorly.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Trading or investing in IPO shares can be riskier than getting
                exposure to established stocks, due to the unpredictability of
                the new listing.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Startup companies or companies that have been in business for
                decades can decide to go public through an IPO. Companies
                typically issue an IPO to raise capital to pay off debts, fund
                growth initiatives, raise their public profile, or to allow
                company insiders to diversify their holdings or create liquidity
                by selling all or a portion of their private shares as part of
                the IPO.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[46.13rem] object-cover"
          alt=""
          src="/i21@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.75rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Type Of Stocks: </span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                <span>Blue-chip Stocks</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Blue-chip stocks are stocks of large, stable companies with a
                long history of stable earnings and dividends, and are typified
                by the stocks composing the Dow Jones Industrial Average,
                including General Electric, IBM, Microsoft, and Pfizer. Because
                of their large size, there is less potential for high growth, so
                most of the return of these stocks is in the form of dividends.
                However, capital gains can be earned from these stocks if they
                are bought in a bear market, when stock prices are depressed
                overall or held for a long time. For instance, during the Great
                Recession of November and December, 2008, and the early part of
                2009, Microsoft was trading below $20 per share, whereas before
                this, Microsoft had been trading at around $30 per share for a
                long time. By mid-February 2020, the stock peaked at $185 per
                share.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Income Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Income stocks generate most of their returns as dividends, and
                the dividends unlike the dividends of preferred stock or the
                interest payments of bonds may grow continuously year after year
                as the companies' earnings grow. These companies have a high
                dividend payout ratio because there are few opportunities to
                invest the money in the business that would yield a higher
                return on stockholders' equity. Hence, many of the these
                companies are already very large, and are also considered
                blue-chip companies, such as General Electric.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Cyclical Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Cyclical stocks cycle with the economic cycles, going up
                strongly when the economy is growing and declining as the
                economy declines. Most of these companies supply capital
                equipment for businesses or big ticket items, such as cars and
                houses, for consumers. Some examples include Alcoa, Caterpillar,
                and Brunswick. The best time to buy and sell these stocks is at
                the bottom and top of a business cycle, respectively.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Defensive Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Defensive stocks are stocks of companies resistant to economic
                cycles, and may even profit from them. When consumers and
                businesses cut back spending, some businesses profit, either
                because they offer a way to cut costs, or because they have the
                lowest prices. For instance, during the Great Recession of late
                2008 and early 2009, people tried to save by doing more for
                themselves. For instance, many people starting cutting hair for
                their families, or coloring their own hair to save the $200 that
                some beauty shops charge. This increased business for
                manufacturers of hair cutters and coloring kits. Auto repair
                shops do better, because people cut back on the purchase of new
                cars, but spend more for maintenance and repairs for their older
                vehicles. And while most retailers were hurting significantly
                during the Great Recession, WalMart was one of the few that
                actually thrived, since Wal-Mart is recognized as providing
                lower prices than other retailers.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>Growth Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Growth stocks are stocks of companies that reinvest most of
                their earnings into their businesses, because it can yield a
                higher return on stockholders' equity, and ultimately, a higher
                return to stockholders, in the form of capital gains, than if
                the money were paid out as dividends. Typically, these companies
                have high P/E ratios because investors expect high growth rates.
                Note, however, that growth stocks are risky. If a
                growth-oriented company doesn't grow as fast as anticipated,
                then its price will drop as investors lower its future
                prospects, so the P/E ratio declines. So even if earnings remain
                stable, the stock price will decline. Another risk is bear
                markets — growth stocks tend to decline much more than
                blue-chips or income stocks in a declining market, because
                investors become pessimistic, and will sell their stocks,
                especially those paying no dividends. One of the main benefits
                of growth stocks is that capital gains, especially long-term
                capital gains where the stock is held for at least 1 year, are
                generally taxed at a lower rate than dividends, which are taxed
                as ordinary income.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Tech Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Tech stocks are the stocks of technology companies, which make
                computer equipment, communication devices, and other
                technological devices. Most tech stocks are listed on NASDAQ.
                The stocks of most tech companies are either considered growth
                stock or speculative stock; some are considered blue-chip, such
                as Intel or Microsoft. However, tech companies are exposed to
                significant risk, because research and development efforts are
                hard to evaluate, and since technology is continually evolving,
                it can quickly change the fortunes of many companies, especially
                when current products are displaced by new products.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Speculative Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Speculative stocks are stocks of companies with little or no
                earnings, or widely varying earnings, but hold great potential
                for appreciation because they are tapping into a new market, are
                operating under new management, have the potential of becoming a
                monopoly, or are developing a potentially very lucrative product
                that could cause the stock price to zoom upward if the company
                is successful. Many Internet companies were considered
                speculative investments. During the stock market bubble of the
                latter half of the 1990's, many of these stocks had ridiculous
                market capitalizations, and yet, many of them had virtually no
                earnings, and many, if not most, have since then, imploded. A
                few, such as Amazon, have grown to become major corporations.
                Other tech companies, such as Facebook, have become de facto
                monopolies, allowing them to earn very high profit margins,
                which is reflected in their stock prices. Many speculative
                stocks are traded frequently by investors — or some would say,
                gamblers — in the hope of making a profit by timing the market,
                since speculative stocks range wildly in price as their
                perceived prospects constantly change.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[55.63rem] object-cover"
          alt=""
          src="/i22@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.75rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>How to Analyze Stocks: </span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                <span>Technical Analysis</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Technical analysis studies the supply and demand of a stock
                within the market. Investors who use technical analysis believe
                that a stock’s historical performance indicates how the stock
                will perform in the future.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>P/E Ratios</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A common method to analyzing a stock is studying its
                price-to-earnings ratio. You calculate the P/E ratio by dividing
                the stock’s market value per share by its earnings per share.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Earnings Per Share</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A company’s earnings per share show how efficiently its revenue
                is flowing down to investors. An increasing EPS is taken as a
                good sign by investors.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{` `}</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>PEG Ratio</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The price-to-earnings growth ratio takes the P/E ratio a step
                further by considering the growth of a company. To calculate the
                PEG, you divide the P/E ratio by the 12-month growth rate.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Book Value</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Another method used to analyze a stock is determining a
                company’s price-to-book ratio. Investors typically use this
                method to find high-growth companies that are undervalued.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.75rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>{`Securities `}</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                <span>&nbsp;</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>
                <span>Equity securities</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Equity almost always refers to stocks and a share of ownership
                in a company (which is possessed by the shareholder). Equity
                securities usually generate regular earnings for shareholders in
                the form of
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                dividends. An equity security does, however, rise and fall in
                value in accord with the financial markets and the company’s
                fortunes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Debt securities</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Debt securities differ from equity securities in an important
                way; they involve borrowed money and the selling of a security.
                They are issued by an individual, company, or government and
                sold to another party for a certain amount, with a promise of
                repayment plus interest. They include a fixed amount (that must
                be repaid), a specified rate of interest, and a maturity date
                (the date when the total amount of the security must be paid
                by). Bonds, bank notes (or promissory notes), and Treasury notes
                are all examples of debt securities. They all are agreements
                made between two parties for an amount to be borrowed and paid
                back – with interest – at a previously-established time.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[43.25rem] object-cover"
          alt=""
          src="/i23@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.75rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Derivatives</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  In the most general sense, a derivative is a financial
                  contract whose value is based on something else. Specifically,
                  the term financial derivative refers to a security whose value
                  is determined by, or derived from the value of another asset.
                  The asset or security from which a derivative gets its value
                  is called an underlying asset or just underlying.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.38rem] h-[22.25rem] object-cover"
            alt=""
            src="/i24@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.75rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Derivatives</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  In the most general sense, a derivative is a financial
                  contract whose value is based on something else. Specifically,
                  the term financial derivative refers to a security whose value
                  is determined by, or derived from the value of another asset.
                  The asset or security from which a derivative gets its value
                  is called an underlying asset or just underlying.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.38rem] h-[22.25rem] object-cover"
            alt=""
            src="/i24@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            An underlying asset might come in many forms but are most commonly
            stocks, bonds, commodities, interest rate, market indexes or
            currencies. The change in the value of a derivative underlying asset
            causes a change in the value of the derivative itself.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Because they involve significant complexity, derivatives aren’t
            generally used as simple buy-low-sell-high or buy-and-hold
            investments. The parties involved in a derivative transaction may
            instead be using the derivative to:
          </p>
          <p className="m-0">
            Hedge a financial position, Speculate on an asset’s price and Use
            funds more effectively.
          </p>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            An underlying asset might come in many forms but are most commonly
            stocks, bonds, commodities, interest rate, market indexes or
            currencies. The change in the value of a derivative underlying asset
            causes a change in the value of the derivative itself.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Because they involve significant complexity, derivatives aren’t
            generally used as simple buy-low-sell-high or buy-and-hold
            investments. The parties involved in a derivative transaction may
            instead be using the derivative to:
          </p>
          <p className="m-0">
            Hedge a financial position, Speculate on an asset’s price and Use
            funds more effectively.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Futures</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                An options contract gives an investor the right, but not the
                obligation, to buy (or sell) shares at a specified price at any
                time before the contract expiration. By contrast, a futures
                contract requires a buyer to purchase the underlying security or
                commodity—and a seller to sell it—on a specific future date,
                unless the holder's position is closed earlier.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                So with Futures, you're obligated to buy or sell at the
                expiration date, however you don't need to pay a premium for the
                contract unlike options
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example. Assume two traders agree to a $7 per bushel price
                on a corn futures contract. If the price of corn moves up to $9,
                the buyer of the contract makes $2 per bushel. The seller, on
                the other hand, loses out on a better deal.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Futures trading hours may differ from stock and options markets.
                Normal trading hours are often 8:30a.m.– 3:00p.m.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Economic Cycles</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The economic cycle is the fluctuating state of an economy from
                  periods of economic expansion and contraction. It is usually
                  measured with the Gross Domestic Product (GDP) of a country or
                  region. Other economic factors, such as employment rates,
                  consumer spending, and interest rates, can also be used to
                  determine the stage of the economic cycle.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[40.13rem] h-[22.25rem] object-cover"
            alt=""
            src="/i26@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            The economic cycle is a trend of upward and downward movements of
            GDP that ultimately determines the overall long-term growth of an
            economy.
          </p>
          <p className="m-0">
            Once the cycle is complete, it continues from the start again. No
            definite rule exists in determining how long each phase lasts; in
            fact, expansion phases can last many years before hitting a peak.
            However, a healthy economy will always go through a contraction
            phase once in a while.
          </p>
          <p className="m-0">
            During the expansion phase, an economy will experience strong
            growth, and interest rates will generally be lower but will begin to
            increase as the expansion matures. The overall production level
            increases, and inflation rates begin to rise as the expansion
            matures.
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson5">
        <div className="w-full">
        <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson4;
